import React, { createContext, useContext, useState } from "react";
import EditUserModal from "../components/User/EditUserModal";

// Crear el contexto
export const ModalContext = createContext();

// Hook personalizado para usar el contexto
export const useModal = () => useContext(ModalContext);

// Proveedor del contexto
export const ModalProvider = ({ children }) => {
  const [modalState, setModalState] = useState({});

  const openModal = (modalName, props = {}) => {
    setModalState((prev) => ({
      ...prev,
      [modalName]: { isOpen: true, props },
    }));
  };

  const closeModal = (modalName) => {
    setModalState((prev) => ({
      ...prev,
      [modalName]: { isOpen: false, props: {} },
    }));
  };

  return (
    <ModalContext.Provider value={{ modalState, openModal, closeModal }}>
      {children}
      <EditUserModal
        open={modalState.editUserModal?.isOpen || false}
        handleClose={() => closeModal('editUserModal')}
        {...modalState.editUserModal?.props}
      />
    </ModalContext.Provider>
  );
};
